import { useSelector } from 'react-redux';
import { getServiceKeysSelector } from 'js/reducers/serviceKeys';

export function useGetServiceKeys() {
  return useSelector(getServiceKeysSelector);
}
